// Angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
// Routing
import { ElearningsRoutingModule } from './elearnings-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { CarouselComponent } from './carousel/carousel.component';
import { ElearningsComponent } from './elearnings.component';
import { FlatDesignModule } from '@medsurf/flat-designs';

/**
 * Elearnings Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgOptimizedImage,
    RouterModule,
    // Routing
    ElearningsRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
    FlatDesignModule,
  ],
  declarations: [
    // Components
    CarouselComponent,
    ElearningsComponent
  ],
})
export class ElearningsModule { }
